var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "payment-summary", class: _vm.customClass }, [
      _c(
        "div",
        {
          staticClass: "summary-toggler",
          on: {
            click: function ($event) {
              _vm.active = !_vm.active
            },
          },
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.formTitle))]),
          _vm._v(" "),
          _c("div", { staticClass: "summary-details" }, [
            _c(
              "label",
              { staticClass: "title" },
              [
                _vm.priceTitle
                  ? [
                      _vm._v(
                        _vm._s(_vm.priceTitle) + ": $" + _vm._s(_vm.calcTotal)
                      ),
                    ]
                  : [_vm._v("$" + _vm._s(_vm.calcTotal))],
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "icon icon-tabler icon-tabler-chevron-down",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "44",
                      height: "44",
                      viewBox: "0 0 24 24",
                      "stroke-width": "1.5",
                      stroke: "#125ea2",
                      fill: "none",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        stroke: "none",
                        d: "M0 0h24v24H0z",
                        fill: "none",
                      },
                    }),
                    _vm._v(" "),
                    _c("polyline", { attrs: { points: "6 9 12 15 18 9" } }),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm._l(_vm.products, function (product) {
                  return _c("li", { key: product["product-code"] }, [
                    _c("label", [
                      _vm._v(_vm._s(product["product-description"])),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("$" + _vm._s(product["total-price"]))]),
                  ])
                }),
                _vm._v(" "),
                _vm.donationPrice > 0
                  ? _c("li", [
                      _c("label", [_vm._v("Donation")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("$" + _vm._s(_vm.donationPrice) + " "),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }